import { filter, map, memoize } from 'lodash';

import { DateShift } from '@mews-distributor/common';
import { HourlyDateShift } from '@mews-distributor/common/src/enums/DateShift';
import { WallClockDateService } from '@mews/framework/datetime';

import { ONE_DAY, WEEK_LENGTH } from '../../constants';

export const getOtherDatesSuggestions = memoize(({ startDate, endDate, minimalStartDate, isHourlyService }) => {
    const dates = {
        start: WallClockDateService.parse(startDate),
        end: WallClockDateService.parse(endDate),
    };

    const otherDates = [
        moveDateInterval(dates, -WEEK_LENGTH, DateShift.IntervalMinusWeek),
        moveDateInterval(dates, WEEK_LENGTH, DateShift.IntervalPlusWeek),
        moveDateInterval(dates, WEEK_LENGTH * 2, DateShift.IntervalPlusTwoWeeks),
        moveDateInterval(dates, WEEK_LENGTH * 3, DateShift.IntervalPlusThreeWeeks),
    ];

    const otherHourlyDates = [
        moveDateInterval(dates, -ONE_DAY, HourlyDateShift.IntervalMinusDay),
        moveDateInterval(dates, ONE_DAY, HourlyDateShift.IntervalPlusDay),
        moveDateInterval(dates, ONE_DAY * 2, HourlyDateShift.IntervalPlusTwoDays),
        moveDateInterval(dates, ONE_DAY * 3, HourlyDateShift.IntervalPlusThreeDays),
    ];

    const filteredValidDates = filter(
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        isHourlyService ? otherHourlyDates : otherDates,
        (ds) =>
            !(
                WallClockDateService.isLess(ds.startDate, minimalStartDate) ||
                WallClockDateService.isLess(ds.endDate, minimalStartDate)
            )
    );
    const filteredDates = map(filteredValidDates, getDatesValue);

    return filteredDates;
});

function moveDateInterval({ start, end }: $TSFixMe, dayCount: $TSFixMe, label: $TSFixMe) {
    return {
        startDate: WallClockDateService.addDays(start, dayCount),
        endDate: WallClockDateService.addDays(end, dayCount),
        label,
    };
}

const getDatesValue = ({ startDate, endDate, label }: $TSFixMe) => ({
    startDate: startDate.value,
    endDate: endDate.value,
    label: label.value,
});
